import React from "react";
import styles from "./easySteps.module.scss";
import logo from "../../assests/krihLogo.png";
import image from "../../assests/PinkFloor.png";

const data = [
  {
    id: 1,
    sNo: "01",
    description:
      "Understand User Needs – Dorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate",
  },
  {
    id: 1,
    sNo: "02",
    description:
      "Understand User Needs – Dorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate",
  },
  {
    id: 1,
    sNo: "03",
    description:
      "Understand User Needs – Dorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate",
  },
  {
    id: 1,
    sNo: "04",
    description:
      "Understand User Needs – Dorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate",
  },
  {
    id: 1,
    sNo: "05",
    description:
      "Understand User Needs – Dorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate",
  },
];

const EasySteps = () => {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.top}>
          <div className={styles.title}>5 Easy steps</div>
          <div className={styles.subTitle}>
            To Improve Your Mobile App Deployment & Guidance
          </div>
        </div>
        <div className={styles.bottom}>
          {/* <div className={styles.logoContainer}>
                <img src={logo} alt="" className={styles.logo}/>
            </div> */}
          <div className={styles.bottomBottom}>
            {data?.map((item) => (
              <div className={styles.point}>
                <div className={styles.right}>
                  <div className={styles.number}>{item?.sNo}</div>
                </div>
                <div className={styles.left}>{item?.description}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <img src={image} alt="" className={styles.img} />
    </div>
  );
};

export default EasySteps;
